<template>
  <div
    :class="[
      wrapperClass,
      {
        'has-error has-danger':
        (validator && validator.$error && !wrapped) || !phoneValid,
      },
    ]"
  >
    <div
      v-if="wrapped"
      :id="'input-wrapper-' + id"
      :class="[
        {
          'has-error has-danger':
          (validator && validator.$error) || errors || !phoneValid,
        },
        inputWrapperClass,
      ]"
    />
    <slot name="icon" />
    <div
      :class="[
        'container__form',
        { validateInput: validator ? ((!validator.$error && type!='tel') || (!validator.$error && type=='tel' && phoneValid)) : field },
        { labelMarginForPlaceHolder: label && !field },
      ]"
    >
      <label
        v-if="label"
        :class="[labelClass]"
        :for="id"
        class="container__label"
      >{{ label
      }}<span v-if="validator && validator.$params.required">*</span></label
      >
      <input
        :autocomplete="autocomplete"
        :class="[inputClass]"
        :disabled="disabled"
        :id="id"
        v-model="field"
        :type="type"
        :maxlength="maxLength"
        :min="min"
        class="form-control container__input"
        @blur="
          $emit('blur', field);
          !validator || validator.$touch();
        "
        @keyup.enter="$emit('keyup-enter')"
        @keyup="onKeyUp"
        @keypress="$emit('keypress')"
        @change="$emit('change')"
      >
    </div>
    <div
      :id="'input-help-block-' + id"
      class="help-block form-text form-control-feedback"
    >
      <template v-for="(error, index) in errors">
        <strong :key="index">{{ error }}</strong>
      </template>
      <template v-if="validator">
        <!-- <strong
          v-if="validator.$params.minLength && validator.$error && !validator.minLength"
        >min length should not be less then {{ validator.$params.minLength.min }} characters!</strong>
        <strong
          v-if="validator.$params.maxLength && validator.$error && !validator.maxLength"
        >max length should not be more then {{ validator.$params.maxLength.max }} characters!</strong> -->
        <!-- <strong
          v-if="validator.$params.required && validator.$error && !validator.required"
        >{{ validationRequiredMessage || `${label.toLowerCase()} is required!` }}</strong> -->
        <strong
          v-if="validator.$params.email && validator.$error && !validator.email"
        >invalid email!</strong
        >
        <strong
          v-if="validator.$params.url && validator.$error && !validator.url"
        >need to add url!</strong
        >
        <strong
          v-if="
            validator.$params.decimal && validator.$error && !validator.decimal
          "
        >field should have decimal value!</strong
        >
        <strong
          v-if="
            validator.$params.sameAs && validator.$error && !validator.sameAs
          "
        >field should match!</strong
        >
      </template>
    </div>
  </div>
</template>

<script>
// import yamli from '../../../vendor/yamli.js'

export default {
	name: 't-input',
	props: {
		autocomplete: {
			type: String,
			default: null
		},
		type: {
			type: String,
			default: 'text'
		},
		label: {
			type: String,
			default: ''
		},
		value: {
			type: [String, Number],
			default: null
		},
		placeholder: {
			type: String,
			default: ''
		},
		validator: {
			type: Object,
			default: null
		},
		validationRequiredMessage: {
			type: String,
			default: null
		},
		labelClass: {
			type: String,
			default: 'col-form-label col-sm-4'
		},
		inputId: {
			type: String,
			default: null
		},
		inputClass: {
			type: String,
			default: ''
		},
		wrapperClass: {
			type: String,
			default: 'form-row'
		},
		inputWrapperClass: {
			type: String,
			default: 'col-sm-8'
		},
		disabled: {
			type: Boolean,
			default: false
		},
		autofocus: {
			type: Boolean,
			default: false
		},
		lowerCase: {
			type: Boolean,
			default: false
		},
		upperCase: {
			type: Boolean,
			default: false
		},
		maxLength: {
			type: Number,
			default: 999
		},
		min: {
			type: Number,
			default: 0
		},
		wrapped: {
			type: Boolean,
			default: false
		},
		errors: {
			type: Array,
			default: () => {
				return null
			}
		}
	},
	data () {
		return {
			phoneValid: true
		}
	},
	computed: {
		field: {
			get () {
				return this.value
			},
			set (value) {
				if (!value) value = null
				// else if (this.type === 'number' && !value && parseInt(value) !== 0) value = null
				// parseInt(value) === 0
				if (value) {
					if (this.type === 'number') {
						this.$emit('input', parseInt(value))
						return
					}

					if (this.lowerCase) {
						value = value.toLowerCase()
						this.$emit('input', value ? value.trim() : value)
						return
					}

					if (this.upperCase) {
						value = value.toUpperCase()
						this.$emit('input', value ? value.trim() : value)
						return
					}
				}

				this.$emit('input', value)
			}
		},
		id () {
			return (
				this.inputId || 't-input-' + Math.random().toString().replace('0.', '')
			)
		}
	},
	mounted () {
		let input = document.getElementById(this.id)

		// if (typeof(Yamli) == "object" && Yamli.init( { uiLanguage: "en" , startMode: "onOrUserDefault" } ))
		// {
		//   console.log(1111,Yamli)//this is running  one time in mounted. it is true
		//   Yamli.yamlify( this.id );
		// }

		if (input.type && input.type === 'password') {
			input.setAttribute('autocomplete', 'new-password')
		}
		if (this.wrapped) {
			let wrapper = document.getElementById(`input-wrapper-${this.id}`)
			let helpBlock = document.getElementById(`input-help-block-${this.id}`)
			wrapper.appendChild(input)
			wrapper.appendChild(helpBlock)
		}
		if (this.autofocus) {
			input.focus()
		}
	},
	methods: {
		onKeyUp (x, y) {
			if (this.type == 'tel') {
				const regex = /^[\+0](?:[0-9] ?){6,14}[0-9]$/
				if (!regex.test(this.field)) this.phoneValid = false
				else this.phoneValid = true
			}
			try {
				$emit('keyup')
			} catch (exc) {}
		},
		setFocus () {
			let input = document.getElementById(this.id)
			input.focus()
		}
	}
}
</script>
<style scoped>
.has-danger .container__form label {
  /* top: -14px; */
  left: -10px;
  /* height: 10%; */
  /* padding:0!important; */
  color: red;
  border: none;
  background: none;
}

.container__label {
  position: absolute;
  display: flex;
  align-items: center;
  font-size: 0.7rem;
  width: auto;
  top: -14px;
  left: 0px;
  height: 10%;
  padding: 0.8em 0.5em;
  color: #6a6d71 ;
  background: noneimportant;
  border: none !important;
}
.container__form {
  position: relative;
}
.container__input {
  width: 100%;
  height: 40px;
  padding: 1em;
  padding-left: 0 !important;
  /* border: 1px solid #2298ef75; */
  background-color: #fff !important;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/common/input/index.vue